import { render, staticRenderFns } from "./UiBookmarkButton.vue?vue&type=template&id=07439f16"
import script from "./UiBookmarkButton.vue?vue&type=script&lang=js"
export * from "./UiBookmarkButton.vue?vue&type=script&lang=js"
import style0 from "./UiBookmarkButton.vue?vue&type=style&index=0&id=07439f16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports